import script from "./TaskListActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskListActionButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__